module.exports = __webpack_public_path__ + "static/contactimage-318f241fde857cd208a7f109d66963f7.jpg";